import { render, staticRenderFns } from "./BackTorule.vue?vue&type=template&id=39e1cf7a&"
import script from "./BackTorule.vue?vue&type=script&lang=ts&"
export * from "./BackTorule.vue?vue&type=script&lang=ts&"
import style0 from "./BackTorule.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports